module.exports = __webpack_public_path__ + "img/logo.1b42252.png";